import { notification as staticNotification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';

let notification: NotificationInstance = staticNotification;

export const setNotificationInstance = (instance: NotificationInstance) => {
  notification = instance;
};

const openNotification = (type: string, obj: any) => {
  if (type === 'success') {
    notification.success({
      message: 'Успешно',
      description: obj?.description || 'Успешно выполнено!',
      placement: 'bottomRight',
    });
  } else if (type === 'error') {
    notification.error({
      message: `${obj?.code}: ${obj?.message}` || 'Ошибка сервера',
      description: obj?.detail || 'Сервер не отвечает попробуйте позже',
      placement: 'bottomRight',
    });
  } else {
    notification.warning({
      message: `${obj?.code}: ${obj?.message}` || 'Ошибка сервера',
      description: obj?.detail || 'Сервер не отвечает попробуйте позже',
      placement: 'bottomRight',
    });
  }
};

export default openNotification;
